import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../Api";
import { exportToPDF } from "../../utils/helper";

// Async thunk for fetching metrics
export const getMetrics = createAsyncThunk("metrics/getMetrics", async (d) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_URL}/schedule/v2/report?${d}`
    );
    return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});


// Async thunk for downloading PDF
export const downloadPdf = createAsyncThunk("metrics/downloadPdf", async (d, { dispatch }) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_URL}/schedule/v2/report?${d}`,
      // { responseType: "blob" }
    );

    // const url = window.URL.createObjectURL(new Blob([res.data]));
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", "report.pdf");
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
    // window.URL.revokeObjectURL(url);

    return { data: res.data.results};
 
    return {};
  } catch (error) {
    throw error;
  }
});

// Slice for metrics
const metricSlice = createSlice({
  name: "metrics",
  initialState: {
    data: {},
    isLoading: false,
    isError: false,
    errMsg: "",
    downloadCompleted:false
  },
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.errMsg = "";
      state.isSuccess = false;
      state.downloadCompleted = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMetrics.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getMetrics.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    });
    builder.addCase(getMetrics.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });

    // Handle downloadPdf actions
    builder.addCase(downloadPdf.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(downloadPdf.fulfilled, (state, action) => {
      state.isLoading = false;
      state.pdfData = action.payload.data;
      exportToPDF(action.payload.data);
      state.downloadCompleted = true;
    });
    builder.addCase(downloadPdf.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
  },
});

// Export reducer
export const metricReducer = metricSlice.reducer;
export const { reset } = metricSlice.actions;